import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,GetImgCertUser_CBack,RespBkMthdMapp,detectEmojisAndSpecialCharacters,
  CallMapMethod_CBack,btnSetColor_CBack,getVersionDetails} from '../function_lib/common_lib';
//import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';



import defaultPic from '../assets/images/user_thumb.png';
import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

let loginUser="";
let userObject="";
let companyName="";
let clsMemberProfile;



//let genderList=["पु.","म.","बा.","बालि."];
let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];

let _exVersionName="";
let _exVersionCode="";
class Update_Android_Verion extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stCheckVersion:{},stMemberProfile:[]};

      this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      clsMemberProfile=this;

      if(window.memc_system){
       
        if(typeof window.memc_system.getAppVersionCode==="function"){
          _exVersionCode="("+window.memc_system.getAppVersionCode()+") ";
        }
        if(typeof window.memc_system.getAppVersionName==="function"){
          _exVersionName=window.memc_system.getAppVersionName();
        }
        
        
      }
    
      }

      getVersionDetailsFromServer(){
        let mapT=[];
        mapT.push({name:"curl_type",value:"checkVersionUpdate"});
        mapT.push({name:"res_func",value:"callBackrrr"});
        mapT.push({name:"local_token",value:userObject[0].id});
        mapT.push({name:"user_type",value:userObject[0].type});
        mapT["res_func"]="callBackrrr";
        mapT["curl_type"]="checkVersionUpdate";
        CallMapMethod_CBack(clsMemberProfile,mapT,function(data,msg){
          if(data!=="0"){
            if(window.memc_system){
              let serTabVersion=JSON.parse(data);
              clsMemberProfile.setState({stCheckVersion:serTabVersion},()=>{
              clsMemberProfile.forceUpdateHandler();
                
              });
            }
           
            //alert(data);
          }
        })

      }

      getMemberProfile(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getMemberProfile"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
       
      
        
        map["res_func"]="callBackrrr";
        map["curl_type"]="getMemberProfile";
        CallMapMethod_CBack(clsMemberProfile,map,function(data,msg){
        //   alert(data);
        //   return;
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
               // alert(JSON.stringify(listData.receipt_amount));
               clsMemberProfile.setState({ stMemberProfile:listData},()=>{
                clsMemberProfile.getVersionDetailsFromServer();
                });
              }
        });
      }

saveWappCompaign(){
 
btnSetColor_CBack(clsMemberProfile,"frmUpdMemberProfile","editMemberProfile",function(checkData,checkMsg){
    //alert(checkData+checkMsg)
    if(checkData===-10){
      alert("Kindly fill required fields");
      return;
    }else if(checkData==="001"){
      Custom_Alert("Updated Successfully",checkMsg,true);
        //window.location.reload();
    }else {
      Custom_Alert("Not Updated",checkMsg,false);
      //alert(checkMsg);
    }
    
  });

  
 
}

 isFloat(n) {
  let checkNum = false;
  if (Number(n)) {
      checkNum = true;
  } else if (n % 1 !== 0) {
      checkNum = true;
  } else {
      checkNum = false;
  }

  return checkNum;
}
okSucc(data,msg){
    if(data==="001"){
alert(msg);
    }else{
        alert("Not updated, kindly contact to support");
    }
    
}
 
componentDidMount(){
    
    
    this.getMemberProfile();
  AjaxCallMethod(this,"okSuccCNOT");
 
$("#app_user_id").val(userObject[0].id);


}

   render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">

<section class="content">
      <div class="container-fluid">
        {this.state.stMemberProfile.length>0?
        <div class="row">
<div className='col-md-12'>
             {/* <!-- About Me Box --> */}
             <div class="card card-primary">
              <div class="card-header">
                <h3 class="card-title">Current Version {getVersionDetails()}</h3>
              </div>
              {/* <!-- /.card-header --> */}
              <div class="card-body">
              <form class="form-group" id="frmUpdPgAndroiVerions" name="frmUpdPgAndroiVerions" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="editMemberProfile" />
                            <input type="hidden" name="m_type" id="m_type" value="editMemberProfile" />
                            
                            <input type="hidden" name="local_token" id="local_token" value={userObject[0].id}/>
                            
                          
                            
                            <div class="card-body">
                                <div className="row">
                                {typeof this.state.stCheckVersion.version_code!=="undefined"?
                                  <div className='col-12'>
                                    {_exVersionCode.trim()===this.state.stCheckVersion.version_code.trim()?<b>{this.state.stCheckVersion?.version_code}The current tab version is up to date; no changes are needed.</b>:
                                     <div class="col-3">
                                     <div class="form-group">
                                     {this.state.stCheckVersion?.version_code} required to update version
                                         <div class="input-group input-group-sm">
                                             <a href="https://cms.ashtechnologies.in/bits_lms/bits_lms_latest.apk" class="btn btn-primary _btnSetColor11">Upgarde App Version</a>
                                             {/* <button type="button" onClick={()=>props.updateTabSrNo("frmTabAllotment")} class="btn btn-primary _btnSetColor11">Submit</button> */}
                                         </div>
                                     </div>
                                 </div>
                                    }
                                  </div>:''}
                               
                               


                                </div>

                                
                                
  {/* other details  */}
          
        
                            {/* end of other details */}                           

                                </div>
                            </form>

              
              </div>

            </div>  
          </div>

          </div>
         :''}
          </div>
          </section>

</div>
</div>
<Alert_Content/>
<Footer/>

          </div>)
      }
}
export default Update_Android_Verion;